export const scrollAnimations = () => {
  const animationTimeline = (target, tr1, tr2) =>
    new ScrollTimeline({
      scrollSource: document.documentElement,
      timeRange: 1,
      fill: "both",
      scrollOffsets: [
        {
          target,
          edge: "end",
          threshold: tr1,
        },
        {
          target,
          edge: "end",
          threshold: tr2,
        },
      ],
    });
  const mainTeaser = document.querySelector(".teaser-latest");
  const sectionLatest = mainTeaser?.closest(".section-latest");

  if (mainTeaser) {
    mainTeaser.animate(
      {
        maskSize: ["50%", "200%"],
        pointerEvents: ["none", "unset"],
      },
      {
        duration: 0.5,
        fill: "both",
        timeline: animationTimeline(sectionLatest, 0.4, 0.95),
      },
    );
    //     transform: ['translateX(-100%)', 'translateX(0)'],
  }
};
